import { ADD_USER, ADD_USER_FAIL, ADD_USER_SUCCESS,USERS_LOADING } from "./actionType"

export const AddNewUser = (user, history, id) => {
  return {
    type: ADD_USER,
    payload: { user, history, id },
  }
}
export const addNewUserSuccess = user => {
  return {
    type: ADD_USER_SUCCESS,
    payload: user,
  }
}
export const usersLoading = (loading) => {
  return {
    type: USERS_LOADING,
    payload: loading,
  }
}
export const addNewUserError = error => {
  return {
    type: ADD_USER_FAIL,
    payload: error,
  }
}
